import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;

  return {
    paddingTop0: {
      paddingTop: '0 !important',
    },
    textCenter: {
      textAlign: 'center',
    },
    verifiedImg: {
      height: '7rem',
      width: '7rem',
      alignSelf: 'center',
      margin: '2rem 0 1rem 0',
    },
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    step: {
      height: 85,
      '@media (max-width: 600px)': {
        minHeight: '85px',
      },
    },
    stepperWrapper: {
      margin: '0 auto',
      paddingTop: '48px',
      paddingLeft: 36,
      paddingRight: 36,
    },
    stepperContent: {
      marginTop: '16px',
    },
    unset: {
      all: 'unset',
    },
    stepWrapper: {
      paddingRight: '4px',
    },
    stepOne: {
      '& .mantine-Stepper-stepIcon': {
        borderColor: colors.success.default,
        backgroundColor: colors.success.subtle,
      },
      '& .mantine-Stepper-verticalSeparatorActive': {
        borderColor: colors.success.default,
      },
    },
    stepTwo: {
      '& .mantine-Stepper-stepIcon': {
        borderColor: colors.warning.default,
        backgroundColor: colors.warning.subtle,
        color: colors.warning.default,
        border: 'dashed',
      },
      '& .mantine-Stepper-verticalSeparator': {
        borderColor: colors.disabled.subtle,
      },
    },
    stepThree: {
      '& .mantine-Stepper-stepIcon': {
        borderColor: colors.disabled.subtle,
        backgroundColor: colors.base.whiteFixed,
      },
    },
    stepCompleted: {
      '& .mantine-Stepper-stepIcon': {
        borderColor: colors.success.default,
        backgroundColor: colors.success.subtle,
      },
      '& .mantine-Stepper-verticalSeparatorActive': {
        borderColor: colors.success.default,
      },
    },
    stepLabel: {
      ...getTypographyStyles('content_md_medium'),
    },
    stepDescription: {
      ...getTypographyStyles('content_xs_regular'),
    },
    subTitle: {
      color: colors.fg.subtle,
      ...getTypographyStyles('heading_2xs_regular'),
      textAlign: "center",
    },
  };
});

export default useStyles;
